import { render, staticRenderFns } from "./MachiningList.vue?vue&type=template&id=08955936&scoped=true&"
import script from "./MachiningList.vue?vue&type=script&lang=js&"
export * from "./MachiningList.vue?vue&type=script&lang=js&"
import style0 from "./MachiningList.vue?vue&type=style&index=0&id=08955936&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08955936",
  null
  
)

export default component.exports